module.exports = __webpack_public_path__ + "img/stadia-s-loading-animation.447278d1.gif";